import gql from 'graphql-tag';
import FieldsTimeslotKind from "graphql/fields/FieldsTimeslotKind";
import FieldsTimeslotKindLimitation from 'graphql/fields/FieldsTimeslotKindLimitation'

export default gql(`
	query timeslot_kinds( $active: String ) {
		timeslot_kinds( active: $active ) {
			${ FieldsTimeslotKind }
			
			limitation {
				${ FieldsTimeslotKindLimitation }
			}
		}
	}
`);

